<template>
  <div class="abnormal-order">
    <a-tabs v-model="currentTab">
      <a-tab-pane
        v-for="tab in tabList"
        :key="tab.value"
      >
        <template slot="tab">
          <div class="abnormal-tab">
            {{tab.label}}
            <a-badge :count="tabNum[tab.value]" />
          </div>
        </template>
      </a-tab-pane>
    </a-tabs>
    <component
      :is="tabComponent[currentTab]"
      @getTotal="getTotal"
    />
  </div>
</template>

<script>
import moment from 'moment'
import TransportOrder from './components/TransportOrder.vue'
import WarehouseOrder from './components/WarehouseOrder.vue'
import { getExceptionStats, getTemperatureExceptionStats, getOrderAlarm } from './api'
import { typeNum } from './const'
import env from '../../../../env/index'

export default {
  name: 'DataOrder',
  components: {
    TransportOrder,
    WarehouseOrder,
  },
  data() {
    return {
      currentTab: 'transport',
      tabComponent: {
        transport: TransportOrder,
        warehouse: WarehouseOrder
      },
      tabList: [
        {
          label: '纯运输',
          value: 'transport'
        },
        {
          label: '仓配一体',
          value: 'warehouse'
        }
      ],
      tabNum: {},
    }
  },
  created() {
    this.getTotal()
  },
  methods: {
    async getTotal() {
      const { type } = this.$route.query
      let res = {}
       const {projectIds,creditCode,customers,customerCode}=this.$store.state.user
       const data={}
       if(creditCode){
         data.customerCodes=customers.map(item=>item.customerCode)
         data.projectIds=projectIds
       }else{
         data.customerCode=customerCode
         data.projectIds=projectIds
       }
      if (type === typeNum.TEMPERATURE.value) {
        res = await getTemperatureExceptionStats(data)
      } else if (type === typeNum.CARGO_WARNING.value) {
        const filter = {
          customerCodes: [this.$store.state.user.customerCode],
          ruleIds: env.ruleIds,
          startTime: moment().subtract(29, "days").startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        }
        res = await getOrderAlarm({
          filter,
          paging: false
        })
        res.transport_cargo_warning_num = res.records?.[0].dataCount || 0
        res.warehouse_cargo_warning_num = 0
      } else {
        res = await getExceptionStats(data)
      }
      this.tabNum = {
        transport: res[typeNum[type].transport],
        warehouse:res[typeNum[type].wharehose],
      }
    }
  }
}
</script>

<style lang="less" scoped>
.abnormal-order {
  background: #fff;
  border-radius: 6px;
  padding: 12px 30px;
  .abnormal-tab {
    /deep/ .ant-badge {
      position: absolute;
      top: 0;
      .ant-scroll-number {
        background: #ED4934;
      }
    }
  }
}
</style>